// Available Apps

import DefaultApp from './DefaultApp';

export const APPS = {
  DEFAULT: DefaultApp,
};
